import { http } from '../../config/axios'

export default function putParametroAplicacao(parametroAplicacao: any): Promise<string> {
  return http
    .put('api/parametroaplicacao', parametroAplicacao)
    .then((res) => {
      return res.data as string
    })
    .catch((error) => {
      console.error('Erro put parametroAplicacao', error)
      throw Error(error.response.data)
    })
}
